import React, { memo } from 'react';
import { ICellRendererParams } from '@trackman/baseball-shared-components';
import { PlayRow } from 'models/PlayEditRow/PlayRow';
import { DefensivePlayerWrapper } from './styles/DefensivePlayerRendererStyles';

interface IProps {
  nameRef: string;
}

const DefensivePlayerRenderer: React.FC<IProps> = memo((props) => {
  const { nameRef } = props;

  return <DefensivePlayerWrapper>{nameRef}</DefensivePlayerWrapper>;
});

const defensivePlayerRenderer = (data: ICellRendererParams<any, PlayRow>) => {
  return <DefensivePlayerRenderer nameRef={data.value?.nameRef || 'Undefined'} />;
};

export default defensivePlayerRenderer;
